import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForActionComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'aDateStart',
    'aDateEnd',
    'artists',
    'headline',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'aDateStart',
      sortable: true,
      type: 'date',
      format: 'L',
      align: 'right',
    },
    {
      property: 'aDateEnd',
      sortable: true,
      type: 'date',
      format: 'L',
      align: 'right',
    },
    {
      property: 'artists',
      type: 'relation',
    },
    {
      property: 'cgCompetitionId',
      sortable: true,
    },
    {
      property: 'contactFormRecipient',
      sortable: true,
    },
    {
      property: 'cmsLanguageId',
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
